import styled from 'styled-components';

export const MemberBannerSection = styled.section`

  @media screen and (max-width: 1024px){
    padding-top: 100px;
  }

  @media screen and (max-width: 991px){
    padding-top: 90px;
  }
    @media screen and (max-width: 767px){
    padding-top: 50px;
  }

  .search-header{
    display:none;
  }
  p{
    color: #01606F;
  }
  .row{
    align-items: center;
  }
  .member-board{
      background: transparent;
      box-shadow: none;
      padding:0;
  }
  .border-member-banner {
    padding-bottom: 0;

    @media screen and (max-width: 1024px){
       padding-bottom: 50px;
    }
    @media screen and (max-width: 991px){
       padding-bottom: 0px;
    }

  }
  .border-member-text{
    padding-bottom:18px;
  }

    .border-member-banner{
      @media screen and (max-width: 1024px){
        padding-top: 80px;
      }
      @media screen and (max-width: 575px){
        padding-top: 120px;
      }
    }
`;

export const MemberTabSection = styled.section`
    .nav-tabs {
      .nav-item {
       margin: 0 4px 0 0;
        .nav-link{
        
        }
      }
    }
`;

export const BoardMembersSection = styled.div`
  display: flex;
  gap: 20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #00000014;
  border-radius: 15px;
  padding: 10px;
  align-items: center;
  margin-bottom:20px;

  @media screen and (max-width: 767px){
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &:last-child{
    margin-bottom:0px;
  }
`;
export const BoardMemberImage = styled.div`
    border-radius: 10px;
    width: 150px;
    height: 150px;
    min-width: 150px;

    @media screen and (max-width: 1024px){
      width: 100px;
      height: 100px;
      min-width: 100px;
    }

    img{
      width:100%;
      height: 100%;
      display: block;
    } 
`;

export const BoardMemberDescription = styled.p`
  color: #000000;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 500;
  line-height: 27px;
  margin-bottom: 0px;

  @media screen and (max-width: 575px){
    font-size: 16px;
    line-height: 24px;
  }

  strong{
      color:#01606F;
      font-weight:700;
  }
`;

export const TeamMembersSection = styled.div`

`;

export const FounderGreatNonprofits = styled.div`
    display: flex;
    background: #01606F 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 15px;
    padding:10px;
    gap:20px;
    margin-bottom: 30px;

    @media screen and (max-width: 767px){
      flex-direction: column;
    }
`;
export const FounderImage = styled.div`
    width:262px;
    max-width:262px;
    height:262px;
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    display: block;
    img{
      width:100%;
    }
`;

export const FounderDetails = styled.div`

`;

export const FounderName = styled.h3`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 700;
    line-height: 27px;
    margin-bottom: 5px;
`;

export const FounderDesignation = styled.span`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 20px;
    display:block;
`;

export const FounderText = styled.p`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 0px;

    @media screen and (max-width: 1024px){
      font-size:16px;
      line-height: 24px;
    }

    strong{
      font-weight: 700;
    }
`;

export const SubTeamMember = styled.div`
    display: flex;
    gap: 20px 24px;
    flex-wrap: wrap;

    @media screen and (max-width: 991px){
      flex-direction: column;
    }
`;

export const TeamMember = styled.div`
    display: flex;
    gap: 20px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 15px;
    padding: 10px 43px 10px 10px;
    width: calc(50% - 12px);
    align-items: center;

    @media screen and (max-width: 1024px){
      align-items: flex-start;
    }
    
    @media screen and (max-width: 991px){
      width: 100%;
    }
    
    @media screen and (max-width: 480px){
      flex-direction: column;
    }
`;
export const MemberImage = styled.div`
    width:150px;
    height:150px;
    min-width:150px;
    img{
        width:100%;
    }
`;
export const MemberText = styled.p`
  color: #000000;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 500;
  line-height: 27px;
  margin-bottom: 0px;

  a{
  text-decoration:none;
  }

  @media screen and (max-width: 575px){
    font-size: 16px;
    line-height: 24px;
  }

  strong{
    color: #01606F;
    font-weight: 700;
  }
  a{
    color: #000000;
    font-weight: 700;
    text-decoration: none;
  }
    span{
     font-weight: 700;
     cursor:pointer;
    }
`;

export const AdvisoryBoardSection = styled.div`

`;

export const AdvisoryBoardList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px 20px;
  @media screen and (max-width: 991px){
    gap: 20px;
  }
`;

export const AdvisoryBoardItem = styled.li`
  width: calc(33.33% - 14px);  
  color: rgb(51 51 51 / 80%);
  font-family: "Jost", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 0;
  text-align: center;

  @media screen and (max-width: 767px){
    font-size: 18px;
    line-height: 28px;
  }

  @media screen and (max-width: 575px){
    width: calc(50% - 10px);
  }

  @media screen and (max-width: 480px){
    font-size: 16px;
    line-height: 26px;
  }
`;
